export default "__VITE_ASSET__ChsmF6r9__"